import { render } from "./CMLoader.vue?vue&type=template&id=93bfc322&scoped=true"
const script = {}

import "./CMLoader.vue?vue&type=style&index=0&id=93bfc322&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93bfc322"]])

export default __exports__